<div class="col-12">
    <dx-data-grid *adaptLoading="!organisation"
                  [dataSource]="dataList"
                  [allowColumnReordering]="true"
                  [allowColumnResizing]="true"
                  [columnAutoWidth]="true"
                  [rowAlternationEnabled]="true"
                  [showRowLines]="true"
                  [showBorders]="true">
        <!-- Options -->
        <dxo-data-grid-header-filter [visible]="true"> </dxo-data-grid-header-filter>
        <dxo-data-grid-filter-row [visible]="true"> </dxo-data-grid-filter-row>
        <dxo-data-grid-column-chooser [enabled]="false"> </dxo-data-grid-column-chooser>
        <dxo-data-grid-paging [pageSize]="100"></dxo-data-grid-paging>
        <dxo-data-grid-pager [showPageSizeSelector]="true"
                             [allowedPageSizes]="[10, 25, 50, 100, 250]"> </dxo-data-grid-pager>
        <dxo-data-grid-group-panel [visible]="true"> </dxo-data-grid-group-panel>
        <dxo-data-grid-grouping [autoExpandAll]="true"> </dxo-data-grid-grouping>
        <dxo-data-grid-export [enabled]="true"
                              fileName="pathways"></dxo-data-grid-export>

        <!-- Columns -->
        <dxi-data-grid-column caption="Pathway"
                              dataField="workflowConnectionId"
                              [customizeText]="getWorkflowId"
                              [groupIndex]="0"
                              sortOrder="desc"
                              [allowGrouping]="true"> </dxi-data-grid-column>

        <dxi-data-grid-column caption="Pathway step"
                              dataField="workflowStepId"> </dxi-data-grid-column>

        <dxi-data-grid-column caption="Status"
                              dataField="status"> </dxi-data-grid-column>

        <dxi-data-grid-column caption="Team"
                              [calculateCellValue]="getTeamName"> </dxi-data-grid-column>

        <dxi-data-grid-column caption="Person"
                              cellTemplate="connectionNameLinkCellTemplate"> </dxi-data-grid-column>

        <dxi-data-grid-column caption="Started"
                              dataField="startTime"
                              [format]="dateFormat"> </dxi-data-grid-column>

        <dxi-data-grid-column caption="Started by"
                              cellTemplate="startedByNameLinkCellTemplate"> </dxi-data-grid-column>

        <dxi-data-grid-column caption="Completed"
                              dataField="completionTime"
                              [format]="dateFormat"> </dxi-data-grid-column>

        <dxi-data-grid-column caption="Completed by"
                              cellTemplate="completedByNameLinkCellTemplate"> </dxi-data-grid-column>

        <div *dxTemplate="let data of 'completedByNameLinkCellTemplate'">
            <adapt-link-person [person]="data.data.completedBy"></adapt-link-person>
        </div>

        <div *dxTemplate="let data of 'startedByNameLinkCellTemplate'">
            <adapt-link-person [person]="data.data.startedBy"></adapt-link-person>
        </div>

        <div *dxTemplate="let data of 'connectionNameLinkCellTemplate'">
            <adapt-link-person [person]="data.data.connection?.personId"></adapt-link-person>
        </div>
    </dx-data-grid>
</div>
